const experience = [
    {
      id: 1,
      title: 'Software Engineer',
      company: 'Exness',
      website: 'https://www.exness.com',
      period: 'Jul 2024 - Present',
      tools: ['Golang', 'Python', 'Kubernetes', 'PostgreSQL', 'Kafka', 'Temporal', 'MongoDB', 'Redis'],
      description: `
      <p>Exness is a global fintech company specializing in online trading solutions, serving over 700,000 active traders monthly with a robust and scalable platform for retail and institutional clients. I joined the Client Experience team.</p>
      
      <ul>
        <li>Designed and developed a backend-for-frontend (BFF) system that enabled the launch of loyalty campaigns without requiring mobile app releases. This reduced the time to launch new experiments from two weeks to just a few days.</li>
        <li>Migrated a legacy customer-facing Python service into two decoupled Go services, improving system stability and maintainability.</li>
        <li>Designed and developed an ETL service for the new loyalty program, transitioning from manual quarterly requalification to real-time status updates.</li>
      </ul>
      `
    },
    {
      id: 2,
      title: 'Tech Lead & Software Engineer',
      company: 'Tabby',
      website: 'https://tabby.ai/',
      period: 'Mar 2022 - Jul 2024',
      tools: ['Golang', 'PostgreSQL', 'Redis', 'PubSub', 'DataDog', 'Kubernetes', 'GCP', 'ArgoCD'],
      description: `
      <p>Tabby is a leading Middle Eastern fintech offering Buy Now, Pay Later solutions. I was part of the Customer Happiness team.</p>
      
      <ul>
        <li>Owned mission-critical services related to debt control and agents management contributing ~10% to company revenue.</li>
        <li>Started as a solo backend engineer and built a cross-functional team of 8, including backend, frontend, QA, PM, and design.</li>
        <li>Transformed the company's loan service into a scalable platform, enabling the launch of a new business line as a new entity <a href="https://www.eltezam.ae/en" target="_blank">Eltezam</a>. This became a separate Debt Control Agency with Tabby as a first client.</li>
        <li>Designed and implemented service synchronization, reducing support ticket costs by ~15%.</li>
        <li>Set up comprehensive observability (metrics, dashboards, alerts) across key services.</li>
      </ul>
    `
    },
    {
      id: 3,
      title: 'Software Engineer',
      company: 'RetailNext, Inc',
      website: 'https://retailnext.net/',
      period: 'Feb 2018 - Mar 2022',
      tools: ['Golang', 'Cassandra', 'Elasticsearch', 'Docker', 'GCP', 'Pub/Sub', 'Kafka', 'TypeScript'],
      description: `
      <p>RetailNext is a U.S.-based SaaS company offering in-store analytics for brick-and-mortar retailers. I joined the internal ops team.</p>
      
      <ul>
        <li>Built internal tools and APIs leveraging core company components, reducing operational costs by approximately $4M annually.</li>
        <li>Implemented data synchronization between NetSuite and internal services via SuiteTalk (SOAP API).</li>
        <li>Automated key workflows using NetSuite's SuiteScript to streamline company processes.</li>
      </ul>`
    },
    {
      id: 4,
      title: 'Software Engineer',
      company: 'Auriga, Inc',
      website: 'https://auriga.com/',
      period: 'Jun 2017 - Feb 2018',
      tools: ['Python (pandas, numpy, bokeh)', 'Git', 'MS SQL', 'basic statistics'],
      description: `
      <p>Auriga is a global software engineering company serving clients in healthcare, banking, and embedded systems.</p>
      
      <ul>
        <li>Designed and developed an interactive data visualization tool with filtering, statistical insights, and configurable alert notifications based on live database updates.</li>
      </ul>`
    },
    {
      id: 5,
      title: 'Software Engineer',
      company: 'Artezio',
      website: 'https://www.artezio.com/',
      period: 'Sep 2016 - Jun 2017',
      tools: ['Python', 'SQL', 'JavaScript'],
      description: `
      <p>Artezio is a custom software company providing enterprise, finance, and travel tech solutions globally.</p>
      
      <ul>
        <li>Developed integrations between a flight meta-search platform and partner services to enable real-time cheap airfare searches.</li>
      </ul>`
    },
    {
      id: 6,
      title: 'QA Engineer',
      company: 'Orion Innovations (ex Mera)',
      website: 'https://www.orioninc.com',
      period: 'Jan 2016 - Sep 2016',
      tools: ['Python (Selenium, Requests)', 'VoIP', 'manual & automated testing', 'TestComplete', 'Jira'],
      description: `
      <p>Orion Innovations is a global technology services company delivering solutions across healthcare, telecom, and enterprise domains.</p>
      
      <ul>
        <li>Developed basic automated regression tests using Python and TestComplete to improve testing efficiency.</li>
      </ul>`
    }
  ];
  
  export default experience;
  